import { CurrencyCode } from 'features/BookingFlow'
import { createContext, FC, PropsWithChildren, useContext, useEffect, useMemo, useState } from 'react'

export type LocalCurrencyContextValue = {
  localCurrency: CurrencyCode
  storeLocalCurrency: (localCurrency: CurrencyCode) => void
}

const LocalCurrencyContext = createContext<LocalCurrencyContextValue | null>(null)

export const DISPLAY_CURRENCY_LOCAL_STORAGE_KEY = 'localDisplayCurrency'

export const LocalCurrencyContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const storedLocalCurrency: CurrencyCode =
    (localStorage.getItem(DISPLAY_CURRENCY_LOCAL_STORAGE_KEY) as CurrencyCode) || 'EUR'
  const [localCurrency, setLocalCurrency] = useState<CurrencyCode>(storedLocalCurrency)

  const storeLocalCurrency = useMemo(
    () => (currencyCode: CurrencyCode) => {
      setLocalCurrency(currencyCode)
    },
    []
  )

  useEffect(() => {
    localStorage.setItem(DISPLAY_CURRENCY_LOCAL_STORAGE_KEY, localCurrency)
  }, [localCurrency])

  const value = useMemo(() => ({ localCurrency, storeLocalCurrency }), [localCurrency, storeLocalCurrency])

  return <LocalCurrencyContext.Provider value={value}>{children}</LocalCurrencyContext.Provider>
}

export function useLocalCurrency() {
  const context = useContext(LocalCurrencyContext)

  if (!context) {
    throw new Error('Must use useLocalCurrency in LocalCurrencyContext')
  }

  return context
}
